import styled from 'styled-components';
import HeaterSvg from '../../assets/amenities/heater.svg';

const HeaterIcon = styled(HeaterSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '2.4rem'};
  height: ${props => props.height || '2.4rem'};
  margin: ${props => props.margin};
`;

export default HeaterIcon;
